import AccessControl from './access_control';

// XPEN-3786: the same rule as the API (services/expense_amount_correction.py).
const CORRECTION_STATUSES = ['Approved', 'Validated'];

/**
 * Why an expense amount cannot be changed for these report or invoice statuses,
 * as a key under `expense_amount_correction`, or null when it can.
 */
export const expenseAmountLockReason = (data, statuses) => {
  const known = statuses.filter(Boolean);
  if (known.includes('Finalized')) return 'expense_account_locked';
  if (known.some((status) => CORRECTION_STATUSES.includes(status)) && !AccessControl.userCanCorrectValidatedExpenses(data)) {
    return 'expense_correction_forbidden';
  }
  return null;
};
